import React from 'react'

type BSVariant = 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'light'

type BadgeProps = {
  variant: BSVariant
  pill?: boolean
  outline?: boolean
  children
  style?: React.CSSProperties
  className?: string
}

export const Badge = ({
  variant = "primary",
  outline = false,
  pill = true,
  children,
  style,
  className
}: BadgeProps) => (
  <span className={[
    "badge",
    "d-inline-flex align-items-center",
    `text-${outline ? '' : 'bg-'}${variant}`,
    pill ? "rounded-pill" : '',
    outline ? `border border-${variant}` : '',
    className || ''
  ].filter(Boolean).join(' ')} style={style}>{children}</span>
)
